import { CurrencyImage } from "../../../tables/transactions-table/columns/currencyImageCell"
import {
	OutboundArs,
	OutboundCrypto,
} from "../../../tables/transactions-table/data/types"
import { Heading2, Heading6 } from "../../../ui/texts/TextStyle"
import BodyBlock from "./BodyBlock"
import BodyItem from "./BodyItem"

const OutboundTransactionModalBody = ({
	transaction,
}: {
	transaction: OutboundArs | OutboundCrypto
}) => {
	switch (transaction.movement_type) {
		case "transfer":
			const sender = transaction.sender
			const recipient = transaction.recipient
			return (
				<div className="grid grid-cols-1 items-center">
					<BodyBlock title={"Resumen"}>
						<BodyItem
							name="Hora"
							value={transaction.time.formatted.time}
							overflow={true}
						/>
						<BodyItem
							name="Fecha"
							value={transaction.time.formatted.date}
							overflow={true}
						/>
						<div className="flex justify-between items-center py-betweenComponents">
							<Heading6 className="font-medium text-text-muted">
								Enviado
							</Heading6>
							<div className="flex-col mb-2 whitespace-nowrap">
								<div className="flex justify-end">
									<CurrencyImage currency={transaction.currency} />
									<Heading2 className="ml-betweenTexts font-medium whitespace-nowrap">
										{transaction.amountSent}
									</Heading2>
									<Heading2 className="ml-betweenTexts font-light">
										{transaction.currency}
									</Heading2>
								</div>
							</div>
						</div>
					</BodyBlock>

					<BodyBlock title={"Destino"}>
						{recipient.alias && (
							<BodyItem name="Alias" value={recipient.alias} />
						)}
						{recipient.cvu && (
							<BodyItem
								name="CVU"
								value={recipient.cvu}
								copy={true}
								overflow={true}
							/>
						)}
						{recipient.bank_entity?.name && (
							<BodyItem name="Banco" value={recipient.bank_entity.name} />
						)}
					</BodyBlock>

					<BodyBlock title={"Origen"}>
						{sender.titular && (
							<BodyItem name="Nombre" value={sender.titular} copy={true} />
						)}
						{sender.cuit && <BodyItem name="CUIT" value={sender.cuit} />}
						{sender.cvu && (
							<BodyItem
								name="CVU"
								value={sender.cvu}
								copy={true}
								overflow={true}
							/>
						)}
					</BodyBlock>
				</div>
			)

		case "crypto":
			return (
				<div className="grid grid-cols-1 items-center">
					<BodyBlock title={"Resumen"}>
						<BodyItem
							name="Hora"
							value={transaction.time.formatted.time}
							overflow={true}
						/>
						<BodyItem
							name="Fecha"
							value={transaction.time.formatted.date}
							overflow={true}
						/>
						<BodyItem name="Red" value={transaction.network} />
						<div className="flex justify-between items-center py-betweenComponents">
							<Heading6 className="font-medium text-text-muted">
								Enviado
							</Heading6>
							<div className="flex-col mb-2 whitespace-nowrap">
								<div className="flex justify-end">
									<CurrencyImage currency={transaction.currency} />
									<Heading2 className="ml-betweenTexts font-medium whitespace-nowrap">
										{transaction.amountSent}
									</Heading2>
									<Heading2 className="ml-betweenTexts font-light">
										{transaction.currency}
									</Heading2>
								</div>
							</div>
						</div>
						{transaction.gas && <BodyItem name="Gas" value={transaction.gas} />}
					</BodyBlock>

					<BodyBlock title={"Destino"}>
						{transaction.recipient.address && (
							<BodyItem
								name="Dirección"
								value={transaction.recipient.address}
								copy={true}
								overflow={true}
							/>
						)}
					</BodyBlock>
				</div>
			)
	}
}

export default OutboundTransactionModalBody
